import { AuthState } from '@Typings/auth.types';
import { RootState } from 'app/store/rootReducer';

export const selectAuthState = (state: RootState): AuthState | undefined =>
  state.auth;
